// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__timer[data-v-0cf2d4d8]{display:flex;align-items:center;gap:8px;border:1px dashed #d4d4d4;border-radius:50px;padding:11px 16px;font-family:Lato;font-style:normal;font-weight:800;font-size:22px;line-height:26px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
